module.exports = __webpack_public_path__ + "static/profile-7a3a6a72d5142b556d2add42d2c1dbd7.png";